import { getEmbarcacaoTanques } from "./embarcacoes.gateway";
import { isEmbarcacaoTanquesEmpty } from "./embarcacoes.types";
import type { EmbarcacaoTanques, EmbarcacaoTanquesState } from "./embarcacoes.types";
import {
  useEmbarcacaoDetailSection,
  type EmbarcacaoDetailSectionQuery,
} from "./use-embarcacao-detail-section";

export const TANQUES_SESSION_EXPIRED_MESSAGE =
  "Sua sessão expirou. Entre novamente para consultar os detalhes da embarcação.";
export const TANQUES_FORBIDDEN_MESSAGE =
  "Você não tem permissão para consultar os detalhes desta embarcação.";
export const TANQUES_NOT_FOUND_MESSAGE = "Embarcação não encontrada.";
export const TANQUES_ERROR_MESSAGE = "Não foi possível carregar os Tanques da embarcação.";

const TANQUES_QUERY: EmbarcacaoDetailSectionQuery<EmbarcacaoTanques> = {
  load: getEmbarcacaoTanques,
  isEmpty: isEmbarcacaoTanquesEmpty,
  messages: {
    sessionExpired: TANQUES_SESSION_EXPIRED_MESSAGE,
    forbidden: TANQUES_FORBIDDEN_MESSAGE,
    notFound: TANQUES_NOT_FOUND_MESSAGE,
    error: TANQUES_ERROR_MESSAGE,
  },
};

interface UseEmbarcacaoTanquesResult extends EmbarcacaoTanquesState {
  reload: () => void;
}

/**
 * Consulta os Tanques da embarcação pedida (AC4). Somente leitura: nenhuma
 * escrita é disparada na abertura nem no fechamento do modal.
 */
export function useEmbarcacaoTanques(id: string): UseEmbarcacaoTanquesResult {
  const { data, ...state } = useEmbarcacaoDetailSection(id, TANQUES_QUERY);

  return { ...state, tanques: data };
}
